<template>
  <div class="order-list">
    <el-card class="query-card">
      <el-form :model="ReqVo" ref="queryForm" label-width="auto" size="small" inline>

        <el-col :span="12">
          <el-form-item :label="$t('settlement.startDate')" prop="startDate">
            <el-date-picker
                v-model="ReqVo.startDate"
                type="datetime"
                :placeholder="$t('startDate')"
                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm:ss"
                :picker-options="startPickerOptions"
                class="full-width"
                :clearable="false"
                :editable="false"
            />
          </el-form-item>
        </el-col>


        <el-col :span="12">
          <el-form-item :label="$t('settlement.endDate')" prop="endDate">
            <el-date-picker
                v-model="ReqVo.endDate"
                type="datetime"
                :placeholder="$t('endDate')"
                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm:ss"
                :picker-options="endPickerOptions"
                class="full-width"
                :clearable="false"
                :editable="false"
            />
          </el-form-item>
        </el-col>

        <el-col :span="24">
          <el-form-item
              :label="$t('settlement.tsId')"
              prop="id"
          >
            <div class="input-with-more">
              <el-input v-model="ReqVo.id" clearable />
            </div>
          </el-form-item>
        </el-col>

        <el-col :span="24">
          <el-form-item style="display: flex; justify-content: center; margin-top: 20px; margin-bottom: 20px;" label-width="0">
            <el-button type="primary" @click="handleSearch">{{ $t('query') }}</el-button>
            <el-button @click="handleReset">{{ $t('reset') }}</el-button>
          </el-form-item>
        </el-col>

      </el-form>
    </el-card>

    <div class="action-toolbar">
      <el-button
          v-if="hasPermission('transactionSettlement/forwardTransactionSettlementList', 'button_detail')"
          :loading="updateLoading"
          @click="PaymentDetails"
          type="primary"
          icon="el-icon-zoom-in"
      >
        {{ $t('settlement.PaymentDetails') }}
      </el-button>
      <el-button
          v-if="hasPermission('transactionSettlement/forwardTransactionSettlementList', 'button_tradeinfo')"
          :loading="updateLoading"
          @click="TransactionSettlement"
          type="primary"
          icon="el-icon-zoom-in"
      >
        {{ $t('settlement.TransactionSettlement') }}
      </el-button>

      <el-button
          v-if="hasPermission('transactionSettlement/forwardTransactionSettlementList', 'downSettDeatil')"
          :loading="downloadLoading1"
          @click="settdetaildownload"
          type="primary"
          icon="el-icon-download"
      >
        {{ $t('settlement.settdetailtitle') }}
      </el-button>

      <el-button
          v-if="hasPermission('transactionSettlement/forwardTransactionSettlementList', 'downTradeDetail')"
          :loading="downloadLoading2"
          @click="tradedownload"
          type="primary"
          icon="el-icon-download"
      >
        {{ $t('settlement.tradeTitle') }}
      </el-button>

      <el-button
          v-if="hasPermission('transactionSettlement/forwardTransactionSettlementList', 'button_downdoc')"
          :loading="downloadLoading3"
          @click="handledownload"
          type="primary"
          icon="el-icon-download"
      >
        {{ $t('button.download') }}
      </el-button>

    </div>


    <el-card class="table-card" style="margin-top: 16px; overflow-x: auto;">
      <el-table :data="tableData" @sort-change="handleSortChange" border  style="width: 100%" v-loading="loading" show-overflow-tooltip
                :cell-style="{whiteSpace: 'nowrap'}"
                :header-cell-style="{whiteSpace: 'nowrap'}"
      >

        <el-table-column width="120" align="center" :label="$t('choose')">
          <template slot-scope="scope">
            <el-radio
                v-model="selectedRowId"
                :label="scope.row.tsId"
                @change="handleRadioChange(scope.row)"
            >
              {{''}}
            </el-radio>
          </template>
        </el-table-column>
        <el-table-column prop="tsId"  :label="$t('settlement.tsId')" :min-width="columnWidths.tsId"></el-table-column>
        <el-table-column :label="$t('settlement.tsAmount')" :min-width="columnWidths.tsAmount" width="250">
          <template #default="scope">
            <span>{{ scope.row.tsBankcurrency }} {{ scope.row.tsAmount }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="tsCreatetime" :label="$t('settlement.tsCreatetime')" :min-width="columnWidths.tsCreatetime" width="250"></el-table-column>
        <el-table-column prop="tsStatus" :label="$t('settlement.tsStatus')" :min-width="columnWidths.tsStatus" width="250">
          <template #default="scope">
            {{ getStatusText(scope.row.tsStatus) }}
          </template>
        </el-table-column>
        <el-table-column prop="tsSetttime"  :label="$t('settlement.tsSetttime')" :min-width="columnWidths.tsSetttime" width="250"></el-table-column>
        <el-table-column prop="tsSettbank" :label="$t('settlement.tsSettbank')" :min-width="columnWidths.tsSettbank"></el-table-column>
        <el-table-column prop="tsFactAmount"  :label="$t('settlement.tsFactAmount')" :min-width="columnWidths.tsFactAmount"></el-table-column>
        <el-table-column prop="tsProtestFee"  :label="$t('settlement.tsProtestFee')":min-width="columnWidths.tsProtestFee"></el-table-column>
        <el-table-column prop="tsRefundFee"  :label="$t('settlement.tsRefundFee')" :min-width="columnWidths.tsRefundFee"></el-table-column>
        <el-table-column prop="tsSettFee" :label="$t('settlement.tsSettFee')" :min-width="columnWidths.tsSettFee"></el-table-column>
        <el-table-column prop="tsMonthFee"  :label="$t('settlement.tsMonthFee')" :min-width="columnWidths.tsMonthFee"></el-table-column>
        <el-table-column prop="tsAmountCurrency"  :label="$t('settlement.tsAmountCurrency')":min-width="columnWidths.tsAmountCurrency"></el-table-column>
        <el-table-column prop="tsProtestAmount"  :label="$t('settlement.tsProtestAmount')" :min-width="columnWidths.tsProtestAmount"></el-table-column>
        <el-table-column prop="tsNkAmount" :label="$t('settlement.tsNkAmount')" :min-width="columnWidths.tsNkAmount"></el-table-column>
        <el-table-column prop="tsOtherAmount"  :label="$t('settlement.tsOtherAmount')" :min-width="columnWidths.tsOtherAmount"></el-table-column>
        <el-table-column prop="tsSpecialAmount"  :label="$t('settlement.tsSpecialAmount')" :min-width="columnWidths.tsSpecialAmount"></el-table-column>
        <el-table-column prop="tsReturnAmount"  :label="$t('settlement.tsReturnAmount')" :min-width="columnWidths.tsReturnAmount"></el-table-column>
        <el-table-column prop="succCountStr" :label="$t('settlement.succCountStr')" :min-width="columnWidths.succCountStr"></el-table-column>
        <el-table-column prop="proCountStr"  :label="$t('settlement.proCountStr')" :min-width="columnWidths.proCountStr"></el-table-column>
        <el-table-column prop="proRateStr"  :label="$t('settlement.proRateStr')" :min-width="columnWidths.proRateStr"></el-table-column>
        <el-table-column prop="tsRemrak"  :label="$t('settlement.tsRemrak')" :min-width="columnWidths.tsRemrak"></el-table-column>
      </el-table>

      <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pagination.page"
          :page-sizes="[10, 20, 50]"
          :page-size="pagination.limit"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pagination.total"
          style="margin-top: 16px; text-align: right;"
      />
    </el-card>

    <!-- 引入并使用子组件，通过 v-model 控制显隐 -->
    <TransferFundsDetail :visible="detailVisible" :row-id="currentRowId" @close="detailVisible = false" />
    <TransactionDetail :visible="detailVisible2" :row-id="currentRowId2" @close="detailVisible2 = false"/>

  </div>




</template>

<script>
import { hasPermission } from "@/utils/permission";
import { postDownload } from "@/utils/download";
import PaymentDetails from './PaymentDetails.vue';
import TransactionSettlement from './TransactionSettlement.vue';
export default {
  name: "OrderList",
  components: {
    TransferFundsDetail: PaymentDetails,
    TransactionDetail: TransactionSettlement
  },
  data() {
    const now = new Date();
    const startOfDay = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0);
    const endOfDay = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59);
    // 一年的毫秒数
    const ONE_YEAR_MS = 365 * 24 * 60 * 60 * 1000;
    return {
      // 开始日期的禁用规则
      startPickerOptions: {
        disabledDate: (time) => {
          return false;
          // if (!this.ReqVo.endDate) return false;
          // // 开始日期不能晚于结束日期，且与结束日期相差不超过1年
          // const endTime = new Date(this.ReqVo.endDate).getTime();
          // return time.getTime() > endTime || (endTime - time.getTime()) > ONE_YEAR_MS;
        }
      },
      // 结束日期的禁用规则
      endPickerOptions: {
        disabledDate: (time) => {
          if (!this.ReqVo.startDate) return false;
          // 结束日期不能早于开始日期，且与开始日期相差不超过1年
          const startTime = new Date(this.ReqVo.startDate).getTime();
          return time.getTime() < startTime;
          // return time.getTime() < startTime || (time.getTime() - startTime) > ONE_YEAR_MS;
        }
      },

      loading: false,
      ReqVo: {
        startDate: startOfDay,
        endDate: endOfDay,
        id:"",

        sortField: undefined,
        sortOrder: undefined
      },

      downloadLoading1: false,
      downloadLoading2: false,
      downloadLoading3: false,

      selectedRowId:"",
      selectedRowData: "",

      // 控制划款交易弹窗的状态
      detailVisible: false,
      currentRowId: null,
      // 控制划款明细交易弹窗的状态
      detailVisible2: false,
      currentRowId2: null,

      updateLoading: false,
      tableData: [],
      columnWidths:{},

      pagination: {
        page: 1,
        limit: 10,
        total: 0,
      },
      pages:"",

    };
  },

  mounted() {
    this.$nextTick(() => {
      this.initColumnWidths();
    });
  },
  methods: {
    getStatusText(status) {
      const statusMap = {
        '-3': this.$t('settlement.tsStatus_3'),
        '-2': this.$t('settlement.tsStatus_2'),
        '-1': this.$t('settlement.tsStatus_1'),
        '0': this.$t('settlement.tsStatus0'),
        '1': this.$t('settlement.tsStatus1'),
        '2': this.$t('settlement.tsStatus2'),
        '3': this.$t('settlement.tsStatus3')
      };
      // 如果找不到对应的状态，返回默认文本
      return statusMap[status] || this.$t('unknownStatus');
    },
    // 按钮
    hasPermission,
    // 排序
    handleSortChange({ column, prop, order }) {
      // prop 是排序的字段名 (例如 'tsId')
      // order 是排序方式：'ascending' (升序), 'descending' (降序), 或者 null (默认不排序)
      if (order === null) {
        this.ReqVo.sortField = undefined;
        this.ReqVo.sortOrder = undefined;
      } else {
        // 正常赋值升序或降序
        this.ReqVo.sortField = prop;
        this.ReqVo.sortOrder = order;
      }

      // 重新调用获取列表的接口
      this.fetchOrderList();
    },



    // 查询
    handleSearch() {
      this.pagination.page = 1; // 重置页码
      this.fetchOrderList();
    },
    // 重置
    handleReset() {
      this.$refs.queryForm.resetFields();
      //this.handleSearch();
    },
    //
    async fetchOrderList() {
      this.loading = true;
      try {
        const params = {
          startDate : this.ReqVo.startDate || undefined,
          endDate : this.ReqVo.endDate || undefined,
          id : this.ReqVo.id || undefined,
          page: this.pagination.page,
          limit: this.pagination.limit,
        };

        const res = await this.$axios.post('/api/settlement/details',  params );

        if (res.data.code === 0) {
          const responseData = res.data.data;

          this.tableData = responseData.records || [];

          this.pagination.total = Number(responseData.total) || 0;
          this.pagination.page = Number(responseData.current) || this.pagination.page;
          this.pagination.limit = Number(responseData.size) || this.pagination.limit;

        } else {
          this.$message.error(res.data.msg);
          this.tableData = [];
          this.pagination.total = 0;
        }
      } catch (err) {
        console.error('查询订单失败:', err);
        this.$message.error(this.$t('requestFailed'));
        this.tableData = [];
        this.pagination.total = 0;
      } finally {
        this.loading = false;
      }
    },

    // 打开划款交易弹窗
    async PaymentDetails() {
      if(!this.selectedRowId){
          this.$message.warning(this.$t('alert_select'));
          return;
      }
      this.currentRowId = this.selectedRowId;
      this.detailVisible = true;
    },

    // 打开划款明细交易弹窗
    async TransactionSettlement() {
      if(!this.selectedRowId){
        this.$message.warning(this.$t('alert_select'));
        return;
      }
      this.currentRowId2 = this.selectedRowId;
      this.detailVisible2 = true;
    },

    // 下载划款明细
    async settdetaildownload() {
      if (!this.selectedRowId) return this.$message.warning(this.$t('alert_select'));
      this.$message.info(this.$t('DownloadInfo'));

      this.downloadLoading1 = true;
      const params = {id : this.selectedRowId};
      try {
        const name = `${this.$t('settlement.settdetailtitle') || '划款明细'}_${Date.now()}.xlsx`;
        const warningText = this.$t('export_truncated_warning');
        await postDownload('/api/settlement/transferFunds/export', params , name, warningText);
        this.$message.success(this.$t('export_success'));
      } catch (e) {
        this.$message.error(e.message || this.$t('export_fail'));
      } finally {
        this.downloadLoading1 = false;
      }
    },

    // 下载划款交易明细
    async tradedownload() {
      if (!this.selectedRowId) return this.$message.warning(this.$t('alert_select'));
      this.$message.info(this.$t('DownloadInfo'));

      this.downloadLoading2 = true;
      const params = {id : this.selectedRowId};
      try {
        const name = `${this.$t('settlement.tradeTitle') || '划款交易明细'}_${Date.now()}.xlsx`;
        const warningText = this.$t('export_truncated_warning');
        await postDownload('/api/settlement/transaction/export', params , name, warningText);
        this.$message.success(this.$t('export_success'));
      } catch (e) {
        this.$message.error(e.message || this.$t('export_fail'));
      } finally {
        this.downloadLoading2 = false;
      }
    },

    // 下载
    async handledownload() {
      if (!this.selectedRowId) return this.$message.warning(this.$t('alert_select'));
      this.$message.info(this.$t('DownloadInfo'));

      this.downloadLoading3 = true;
      const params = {id : this.selectedRowId};
      try {
        const name = `${this.$t('settlement.SettlementDetails') || '结算明细'}_${Date.now()}.doc`;
        const warningText = this.$t('export_truncated_warning');
        await postDownload('/api/settlement/details/export', params , name, warningText);
        this.$message.success(this.$t('export_success'));
      } catch (e) {
        this.$message.error(e.message || this.$t('export_fail'));
      } finally {
        this.downloadLoading3 = false;
      }
    },

    // 分页：每页条数变化
    handleSizeChange(val) {
      this.pagination.limit = val;
      this.pagination.page = 1; //
      this.fetchOrderList(); //
    },
    // 分页：当前页变化
    handleCurrentChange(val) {
      this.pagination.page = val;
      this.fetchOrderList(); //
    },
    // 处理选择id
    handleRadioChange(row) {
      this.selectedRowData = row;

    },

    // 表头宽度
    initColumnWidths() {
      const cols = [
        "tsId",
        "tsAmount",
        "tsCreatetime",
        "tsStatus",
        "tsSetttime",
        "tsSettbank",
        "tsFactAmount",
        "tsProtestFee",
        "tsRefundFee",
        "tsSettFee",
        "tsMonthFee",
        "tsAmountCurrency",
        "tsProtestAmount",
        "tsNkAmount",
        "tsOtherAmount",
        "tsSpecialAmount",
        "tsReturnAmount",
        "succCountStr",
        "proCountStr",
        "proRateStr",
        "tsRemrak",
      ];
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');

      ctx.font = '14px Helvetica';

      cols.forEach(key => {
        const label = this.$t(
            `settlement.${key}`
        );

        this.$set(
            this.columnWidths,
            key,
            Math.ceil(ctx.measureText(label).width) + 50
        );
      });
    }
  },
};
</script>

<style>
/* 全局样式 - 表头居中 */
.el-table th .cell {
  white-space: nowrap !important;
  text-align: center !important;
}

.el-table .cell {
  white-space: nowrap !important;
  text-align: center !important;
}
</style>

<style scoped>
.order-list {
  padding: 20px;
}

/* 确保输入框、下拉框、时间选择器在栅格中占满 100% 宽度 */
.full-width {
  width: 100% !important;
}

/* 使用 Flex 布局优雅处理 输入框 + More 按钮 的组合 */
.input-with-more {
  display: flex;
  align-items: center;
  width: 100%;
}

.input-with-more .el-input {
  flex: 1; /* 让输入框自动撑满剩余空间 */
}

.input-with-more .el-button {
  margin-left: 10px; /* 按钮和输入框之间的间距 */
  flex-shrink: 0; /* 防止按钮被挤压变形 */
}

/* 保持表格原有样式不变 */
.table-card ::v-deep .el-table .cell {
  white-space: nowrap !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
}
.table-card ::v-deep .el-table th .cell {
  white-space: nowrap !important;
}
.table-card {
  overflow-x: auto;
}

.table-card ::v-deep .el-table {
  min-width: 100%;
}


/* --- 修改 1：美化查询表单的标签字体 --- */
.query-card /deep/ .el-form-item__label {
  white-space: nowrap !important;
  font-weight: 600 !important; /* 强制加粗生效 */
  color: #303133 !important; /* 强制颜色深灰生效 */
  font-size: 14px !important;
  letter-spacing: 0.5px !important;
  min-width: 140px;
  text-align: right;
}

/* --- 修改 2：美化输入框内的字体和边框 --- */
.query-card /deep/ .el-input__inner {
  font-weight: 500 !important; /* 强制生效 */
  color: #606266 !important; /* 强制生效 */
  border-radius: 6px !important; /* 强制微圆角生效 */
}
/* 鼠标悬浮时输入框边框颜色加深一点点（可选增亮效果） */
.query-card /deep/ .el-input__inner:hover {
  border-color: #c0c4cc !important;
}


/* 操作工具栏样式 */
.action-toolbar {
  margin-top: 16px;     /* 与上方查询卡片拉开间距 */
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

/* 按钮之间的间距调整 */
.action-toolbar .el-button {
  margin-left: 10px;
  margin-right: 0;
}

.heavy-disabled /deep/ .el-input__inner {
  padding-right: 20px;
  color: #333333 !important;
  font-weight: bold !important;
  -webkit-text-fill-color: #333333 !important;
}


</style>




// WEBPACK FOOTER //
// src/view/transactionSettlement/forwardTransactionSettlementList.vue